import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Phone, MapPin } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <div className="text-3xl font-bold">
              <span className="text-[#FFB830]">La</span>
              <span className="text-[#7CB342]"> Piña</span>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('inicio')}
              className="text-gray-700 hover:text-[#7CB342] transition-colors font-medium"
            >
              Inicio
            </button>
            <button
              onClick={() => scrollToSection('menu')}
              className="text-gray-700 hover:text-[#7CB342] transition-colors font-medium"
            >
              Menú
            </button>
            <button
              onClick={() => scrollToSection('ubicacion')}
              className="text-gray-700 hover:text-[#7CB342] transition-colors font-medium"
            >
              Ubicación
            </button>
            <button
              onClick={() => scrollToSection('contacto')}
              className="text-gray-700 hover:text-[#7CB342] transition-colors font-medium"
            >
              Contacto
            </button>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Button
              onClick={() => scrollToSection('reservas')}
              className="bg-[#FFB830] hover:bg-[#FFA500] text-white font-semibold px-6 py-2 rounded-full transition-all duration-300 hover:scale-105 shadow-lg"
            >
              Hacer Reserva
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-gray-700 hover:text-[#7CB342] transition-colors"
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
          <nav className="container mx-auto px-4 py-4 flex flex-col space-y-4">
            <button
              onClick={() => scrollToSection('inicio')}
              className="text-gray-700 hover:text-[#7CB342] transition-colors font-medium text-left py-2"
            >
              Inicio
            </button>
            <button
              onClick={() => scrollToSection('menu')}
              className="text-gray-700 hover:text-[#7CB342] transition-colors font-medium text-left py-2"
            >
              Menú
            </button>
            <button
              onClick={() => scrollToSection('ubicacion')}
              className="text-gray-700 hover:text-[#7CB342] transition-colors font-medium text-left py-2"
            >
              Ubicación
            </button>
            <button
              onClick={() => scrollToSection('contacto')}
              className="text-gray-700 hover:text-[#7CB342] transition-colors font-medium text-left py-2"
            >
              Contacto
            </button>
            <Button
              onClick={() => scrollToSection('reservas')}
              className="bg-[#FFB830] hover:bg-[#FFA500] text-white font-semibold w-full rounded-full"
            >
              Hacer Reserva
            </Button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
